export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  // localStorage persists sessions across tabs/refreshes (internal tool, acceptable XSS risk).
  // Mitigated by: Auth0 refresh token rotation, short access token TTL, CSP headers on Vercel.
  cacheLocation: 'localstorage' as const,
  useRefreshTokens: true,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: 'openid profile email',
  },
} as const
